import script from "./PartnerProjectForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerProjectForm.vue?vue&type=script&setup=true&lang=js"

import "./PartnerProjectForm.vue?vue&type=style&index=0&id=17dab92e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17dab92e"]])

export default __exports__